export default __webpack_public_path__ + "static/media/Gloves of the Precursor.1f72d59d.jpg";